import { X } from "lucide-react";
import glassSandImage from "@/assets/images/predictions/glass_sand.jpeg";
import mascotImage from "@/assets/images/predictions/mascot.png";

type Props = { onClose: () => void };

export const OnboardingHeader = ({ onClose }: Props) => {
  return (
    <div className="relative h-36 w-full overflow-hidden bg-gray-900 md:h-44">
      <div
        aria-hidden
        className="pointer-events-none absolute -inset-4 bg-cover bg-center bg-no-repeat blur-[2px]"
        style={{ backgroundImage: `url(${glassSandImage})` }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/20 via-black/30 to-black/50"
      />
      <img
        src={mascotImage}
        alt=""
        aria-hidden
        className="pointer-events-none absolute -bottom-6 right-2 h-40 select-none drop-shadow-2xl md:-bottom-8 md:right-6 md:h-48"
      />
      <button
        type="button"
        onClick={onClose}
        aria-label="Fermer"
        className="absolute right-4 top-4 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-white text-gray-900 ring-1 ring-black/10 transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-white"
      >
        <X size={18} />
      </button>
    </div>
  );
};

OnboardingHeader.displayName = "OnboardingHeader";
